//封装的request.js文件
import axios from "axios";

export function request(config) {
  const instance = axios.create({
    baseURL: "https://version.sxmhba.com/api/",
    timeout: 5000
  });

//拦截器
  instance.interceptors.response.use(
    res => {
      // console.log(res);
      return res.data;
    },
    err => console.log(err)
  );

  instance.interceptors.request.use(
    res => {
      if (localStorage.getItem("accessToken")) {
        res.headers.common['lin2144-server'] = localStorage.getItem("accessToken")
      }
      return res;
    },
    function(err) {
      console.log("失败信息" + err);
    }
  );

  return instance(config);
}

export function request1(config) {
  const instance1 = axios.create({
    baseURL: "http://3867w7i321.zicp.vip/web/",
    timeout: 5000
  });

//拦截器
  instance1.interceptors.response.use(
    res => {
      // console.log(res);
      return res.data;
    },
    err => console.log(err)
  );

  instance1.interceptors.request.use(
    res => {
      return res;
    },
    function(err) {
      console.log("失败信息" + err);
    }
  );

  return instance1(config);
}



// WEBPACK FOOTER //
// ./src/axios/request.js